import React, { useContext, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import i18n from '../../../i18n';

import { ProtectedRouteContext } from '../../Context';
import { questionTypes } from '../../../utils/enums';

import Checkboxes from './question/Checkboxes';
import DatePick from './question/DatePick';
import Dropdown from './question/Dropdown';
import File from './question/File';
import LabelOnly from './question/LabelOnly';
import Radio from './question/Radio';
import Signature from './question/Signature';
import SingleLinePlainText from './question/SingleLinePlainText';
import Strikethrough from './question/Strikethrough';
import OutputPreview from './question/OutputPreview';
import Table from './question/Table';
import DropdownMultiple from './question/dropdownMultiple';
import MultiLinePlainText from './question/multiLinePlainText';

import './ApplicationSection.scss';

export default function ApplicationSection(props) {
    const section = props.section;
    const disabled = props.disabled;
    const appInstanceId = props.appInstanceId;
    const answerUpdated = props.answerUpdated; // callback func when any answer gets updated
    const { userSettings } = useContext(ProtectedRouteContext);
    const [shouldShowErrors, setShouldShowErrors] = useState(typeof props?.shouldShowErrors === 'boolean' ? props.shouldShowErrors : false);
    const [lang, setLang] = useState(
        typeof userSettings?.LanguagePreference === 'string' ? userSettings.LanguagePreference : i18n.language
    );

    useEffect(() => {
        if (typeof userSettings?.LanguagePreference === 'string') {
            setLang(userSettings.LanguagePreference);
        }
    }, [userSettings.LanguagePreference]);

    useEffect(() => {
        setShouldShowErrors((prev) => (typeof props?.shouldShowErrors === 'boolean' ? props.shouldShowErrors : prev));
    }, [props.shouldShowErrors]);

    return (
        <div className="application-section">
            <ReactMarkdown
                children={section.headerMarkdown[lang]}
                className="application-header"
            />
            {section.questions.map((question) => {
                return (
                    <div key={question.id}>
                        <form autoComplete="off">
                            {/* TODO #TechnicalDebt from SHIP-1666 - Find a better way to do this that affects all browsers and doesn't require this many form elements */}
                            {question.questionType === questionTypes.SingleLinePlainText ? (
                                <SingleLinePlainText
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    shouldShowErrors={shouldShowErrors}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.MultiLinePlainText ? (
                                <MultiLinePlainText
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    shouldShowErrors={shouldShowErrors}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.Dropdown ? (
                                <Dropdown
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    shouldShowErrors={shouldShowErrors}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.DropdownMultichoice ? (
                                <DropdownMultiple
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    shouldShowErrors={shouldShowErrors}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.Radio ? (
                                <Radio
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    shouldShowErrors={shouldShowErrors}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.Checkbox ? (
                                <Checkboxes
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    shouldShowErrors={shouldShowErrors}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.DatePicker ? (
                                <DatePick
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    shouldShowErrors={shouldShowErrors}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.FileUpload ? (
                                <File
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    shouldShowErrors={shouldShowErrors}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.SignaturePad ? (
                                <Signature
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    shouldShowErrors={shouldShowErrors}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.LabelOnly ? (
                                <LabelOnly
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.OutputPreview ? (
                                <OutputPreview
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.Strikethrough ? (
                                <Strikethrough
                                    appInstanceId={appInstanceId}
                                    question={question}
                                    answerUpdated={answerUpdated}
                                    disabled={disabled}
                                />
                            ) : null}

                            {question.questionType === questionTypes.Table ? (
                                <Table
                                    appInstanceId={appInstanceId}
                                    question={question}
                                />
                            ) : null}
                        </form>
                    </div>
                );
            })}
        </div>
    );
}
